import { format } from 'date-fns';
import { es } from 'date-fns/locale';
const CurrencyFormatter = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
});
const DecimSeparatorFormatter = new Intl.NumberFormat('en-US');

var PercentageFormatter = new Intl.NumberFormat("en-US", {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  
export function generatePassword(){
    const wishlist = '~!@-#$0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnñopqrstuvwxyz~!@-#$';
    var randPassword = new Array(12).fill(0).map(x => (function(chars) { let umax = Math.pow(2, 32), r = new Uint32Array(1), max = umax - (umax % chars.length); do { crypto.getRandomValues(r); } while(r[0] > max); return chars[r[0] % chars.length]; })(wishlist)).join('');
    return randPassword;

}

export function isValid(value: any) {
	return (value !== undefined && value !== null && value.toString() !== "" && value.toString().trim());
}

export function fDate (value: string) {
    if(isValid(value)) return format(new Date(value), "dd/MM/yyyy");
    return value;
}

export function fDatetime (value: string) {
    if(isValid(value)) return format(new Date(value), "PPPppp", { locale: es }).replace(" GMT-6", "");
    return value;
}

export function fDateCustom (value: string, formato: string) {
    if(isValid(value)) return format(new Date(value), formato, { locale: es }).replace(" GMT-6", "");
    return value;
}

export function fCurrency(value: number){
    if(isValid(value)) return CurrencyFormatter.format(value);
    return value;
}

export function fDecim(value: number | string){
    if(isValid(value)) return DecimSeparatorFormatter.format(Number(value));
    return value;
}

export function fPercent(value: number | string){
    if(isValid(value)) return PercentageFormatter.format(Number(value));
    return value;
}

export function sortObjects(data: Array<any>, field: string, direction?: string): Array<any>{
    if(field.includes(".")){
        return data.slice().sort((a: any, b: any)=>{ 
            return compare(getField(field, a), getField(field, b)) * (direction === "desc" ? -1 : 1);
        });
    } else {
        return data.slice().sort((a: any, b: any)=> compare(a[field], b[field]) * (direction === "desc" ? -1 : 1));
    }
}

export function getField(field: string, object: object){
    let obj: any = {...object};
    field.split(".").forEach((f: string) => obj = obj[f]);
    return obj;
}

export function getFileNameFromSrc(src: string): string{
    const partsSrc =src.split('/');
    const name = partsSrc[partsSrc.length - 1];
    return name;
}

export function eliminarTildes(str: string) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function specialTrim(str: string) {
    return str.trim().replace(/\s\s+/g, ' ')
  }

export const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

export function enumToArray(enumToChange: any, type: 'normal' | 'allValues' | 'allKeys') {
    const keys = Object.keys(enumToChange);
    const enumConverted = keys.map((keyEnum: string) => {
        if (type === 'allKeys') {
            return { label: keyEnum, value: keyEnum };
        } else if (type === 'allValues') {
            return { label: enumToChange[keyEnum], value: enumToChange[keyEnum] };
        } else {
            return { label: enumToChange[keyEnum], value: keyEnum };
        }
    });
    return enumConverted || [];
}
